module.exports = __webpack_public_path__ + "img/brick-city-0.90bca9ec.png";